<template>
  <div class="third-party-pickup">
    <div class="toggle-row" @click="toggleEnabled">
      <span class="toggle-label">Family or friends will collect bags on my behalf</span>
      <span class="toggle-switch" :class="{ on: enabled }">
        <span class="toggle-knob"></span>
      </span>
    </div>

    <transition name="panel-slide">
      <div v-if="enabled" class="pickup-fields">
        <div class="name-row">
          <div class="field">
            <label class="field-label">First Name</label>
            <input type="text" class="field-input" :value="data.other_first_name" @input="updateField('other_first_name', $event.target.value)" placeholder="First name" />
          </div>
          <div class="field">
            <label class="field-label">Last Name</label>
            <input type="text" class="field-input" :value="data.other_last_name" @input="updateField('other_last_name', $event.target.value)" placeholder="Last name" />
          </div>
        </div>

        <div class="name-row">
          <div class="field">
            <label class="field-label">Passport Number</label>
            <input type="text" class="field-input" :value="data.other_passport" @input="updateField('other_passport', $event.target.value)" placeholder="Passport" />
          </div>
          <div class="field">
            <label class="field-label">Licence Number</label>
            <input type="text" class="field-input" :value="data.other_licence" @input="updateField('other_licence', $event.target.value)" placeholder="Licence" />
          </div>
        </div>

        <div class="field">
          <label class="field-label">Email</label>
          <input type="email" class="field-input" :value="data.other_email" @input="updateField('other_email', $event.target.value)" placeholder="email@example.com" />
        </div>

        <div class="field">
          <label class="field-label">Mobile Number</label>
          <div class="phone-row">
            <PhonePrefixSelect class="phone-prefix" :value="data.other_mobile_prefix || '+61'" @change="updateField('other_mobile_prefix', $event)" />
            <input type="tel" class="field-input phone-number" :value="data.other_mobile_number" @input="updateField('other_mobile_number', $event.target.value)" placeholder="412 345 678" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PhonePrefixSelect from './PhonePrefixSelect.vue'

const EMPTY = {
  other_first_name: '', other_last_name: '',
  other_passport: '', other_licence: '',
  other_email: '', other_mobile_prefix: '+61', other_mobile_number: ''
}

export default {
  name: 'ThirdPartyPickup',
  components: {
    PhonePrefixSelect
  },
  props: {
    value: { type: Object, default: function () { return Object.assign({}, EMPTY) } },
    enabled: { type: Boolean, default: false }
  },
  computed: {
    data () {
      return Object.assign({}, EMPTY, this.value)
    }
  },
  methods: {
    toggleEnabled () {
      this.$emit('change', { enabled: !this.enabled, data: this.data })
    },
    updateField (key, val) {
      var next = Object.assign({}, this.data)
      next[key] = val
      this.$emit('change', { enabled: this.enabled, data: next })
    }
  }
}
</script>

<style scoped>
.third-party-pickup { margin-bottom: 20px; }
.toggle-row { display: flex; align-items: center; justify-content: space-between; padding: 14px 0; cursor: pointer; user-select: none; }
.toggle-label { font-size: 14px; font-weight: 600; color: #1e336f; }
.toggle-switch { width: 46px; height: 26px; border-radius: 13px; background: #d1d5db; position: relative; transition: background .25s; flex-shrink: 0; }
.toggle-switch.on { background: #1e336f; }
.toggle-knob { position: absolute; top: 3px; left: 3px; width: 20px; height: 20px; border-radius: 50%; background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,.15); transition: transform .25s; }
.toggle-switch.on .toggle-knob { transform: translateX(20px); }
.pickup-fields { padding-top: 4px; }
.name-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.field { margin-bottom: 14px; }
.field-label { display: block; font-size: 13px; font-weight: 600; color: #1e336f; margin-bottom: 6px; }
.field-input {
  width: 100%; min-height: 44px; padding: 10px 12px; font-size: 15px; border: 1px solid #e8ecf1;
  border-radius: 8px; background: #fff; color: #1e336f; outline: none; transition: border-color .2s;
}
.field-input:focus { border-color: #1e336f; box-shadow: 0 0 0 3px rgba(30,51,111,.12); }
.phone-row { display: flex; gap: 8px; }
.phone-prefix { flex: 5 1 0; min-width: 0; }
.phone-number { flex: 6 1 0; min-width: 0; }
.panel-slide-enter-active, .panel-slide-leave-active { transition: all .3s ease; overflow: hidden; }
.panel-slide-enter, .panel-slide-leave-to { opacity: 0; max-height: 0; }
.panel-slide-enter-to, .panel-slide-leave { opacity: 1; max-height: 600px; }
@media (max-width: 480px) { .name-row { grid-template-columns: 1fr; } }
</style>



// WEBPACK FOOTER //
// src/components/ThirdPartyPickup.vue